import React from 'react';
import PropTypes from 'prop-types';

export const SelectItem = ({value, content}) => {
    return (
        <div value={value}>
            <span>{content}</span>
        </div>
    )
};

SelectItem.propTypes = () => ({
    value: PropTypes.string,
    flag: PropTypes.string,
    content: PropTypes.string,
});
